import { getValidDate } from 'lib/utils'

export const contractTypes = [
  { label: 'Запрос', code: 'request' },
  { label: 'Кредитный продукт', code: 'creditProduct' },
  { label: 'Обеспечение', code: 'procuring' }
]

export const getRequestData = contract => {
  return [
    { label: 'Дата создания', value: getValidDate(contract?.creationDate) },
    { label: 'Дата загрузки', value: getValidDate(contract?.loadingDate) },
    { label: 'Код контракта', value: contract?.contractName || '-' },
    { label: 'Кредитный продукт', value: contract?.contractCode || '-' },
    { label: 'Сумма займа', value: `${contract?.loanAmount?.toString()?.thousandSeparator() || 0} ₸` },
    { label: 'Валюта', value: contract?.currencyName || '-' },
    { label: 'Срок займа', value: contract?.trancheCount || '-' },
    { label: 'Номинальная процентная ставка', value: contract?.interestForTranche || '-' },
    { label: 'Ступени займа', value: contract?.loanStage || 0 },
    { label: 'Филиал', value: contract?.branchName || '-' },
    { label: 'Подразделение', value: contract?.subdivisionName || '-' },
    { label: 'Специалист по займам', value: contract?.creditOfficerName || '-' },
    { label: 'Источник финансирования', value: contract?.donorName || '-' },
    { label: 'Категория займа', value: contract?.loanCategoryName || '-' },
    { label: 'Тип отсрочки', value: contract?.defermentType || '-' },
    {
      label: 'Тип распределения отсроченных сумм при отсрочке',
      value: contract?.defermentDistributionType || '-'
    },
    { label: 'Количество отсроченных траншей', value: contract?.defermentTranchesQty || 0 },
    {
      label: 'Кол-во траншей для пролонгации при отсрочке',
      value: contract?.defermentProlongationTranchesQty || 0
    },
    { label: 'Длительность периода между погашениями', value: contract?.trancheDuration || '-' },
    { label: 'Остановлено начисление штрафов\n', value: contract?.accrualStop ? 'Да' : 'Нет' || '-' }
  ]
}

export const getRequestCheckboxData = contract => {
  return [
    { label: 'Переносить проценты по пролонгированным контрактам на последний транш', value: null },
    { label: 'Оригиналы документов получены', value: null },
    { label: 'К выдаче', value: null },
    { label: 'В процессе выдачи', value: null }
  ]
}

export const getCreditProductData = contract => {
  return [
    { label: 'Порядок погашения', value: contract?.repaymentSequenceName || '-' },
    { label: 'Вид начисления штрафа', value: contract?.penaltyTypeName || '-' },
    { label: 'Отсроченный льготный период (в днях)', value: contract?.interestLgotPeriod || 0 },
    {
      label: 'Процентная ставка для отсроченного льготного периода',
      value: contract?.interestLgotRate || 0
    },
    { label: 'Беспроцентный льготный период (в дни)', value: contract?.interestGracePeriod || 0 },
    { label: 'Процентная ставка при просрочке', value: contract?.delinquencyIntRate || 0 },
    { label: 'Метод расчета дат', value: contract?.dateCalcMethodName || '-' },
    { label: 'Тип процентной ставки', value: contract?.interestRateTypeName || '-' },
    { label: 'Метод расчета процентов', value: contract?.interestCalcMethodName || '-' },
    { label: 'Метод начисления процентов', value: contract?.interestChargeMethodName || '-' },
    { label: 'Метод распределения основной суммы', value: contract?.principalDistribMethodName || '-' },
    { label: 'Метод зачета переплаты', value: contract?.forepaymentConsiderationMethodName || '-' },
    { label: 'Тип кредитной линии', value: contract?.creditLineId || '-' },
    { label: 'Срок пролонгации', value: contract?.prolongationPeriod || 0 },
    { label: 'Штраф за опоздание (фикс. сумма)', value: contract?.fixedDelayPenalty || 0 },
    {
      label: 'Кол-во дней начисления процентов по окончанию графика',
      value: contract?.extraIntDaysQty || '-'
    },
    {
      label: 'Кол-во дней после окончания графика до остановки штрафов',
      value: contract?.qtyDaysStopPenaltyOnClose || 0
    },
    { label: 'Кол-во дней до перехода на ставку при просрочке', value: contract?.delinqIntRateDelay || 0 },
    { label: 'Период обязательного начисления', value: contract?.mandatoryChargePeriod || 0 },
    { label: 'День просрочки для начисления штрафа за опоздание', value: contract?.delayPenaltyDay || 0 }
  ]
}

export const getCreditProductCheckboxData = contract => {
  return [
    { label: 'Досрочная пролонгация', value: contract?.earlyProlongationFromCurrentDate || null },
    { label: 'Полное смещение графика от фактической даты выдачи', value: contract?.fullScheduleDatesRecalc || null },
    { label: 'Перерасчет графика в дату планового платежа', value: contract?.scheduleRecalcEnabled || null },
    { label: 'Первые выходные штрафы не начислять', value: contract?.firstWeekendWithoutPenalty || null },
    { label: 'Контроль краткосрочности займа', value: contract?.shortTermControl || null },
    { label: 'Рассчитывать проценты от суммы в контракте', value: contract?.interestOnLoanAmount || null },
    { label: 'Не переносить с праздников и выходных', value: contract?.allowHolidaysPayment || null },
    { label: 'Начислять проценты на просроченную ОС', value: contract?.calcInterestOnDelinqBalance || null },
    {
      label: 'Начислять проценты на просроченную ОС только по ставке при просрочке',
      value: contract?.calcIntOnDelinqBalanceOnlyAtDelinqIntRate || null
    },
    { label: 'Начислять проценты в день выдачи контракта', value: contract?.calcIntOnIssueDate || null },
    { label: 'Начислять проценты по окончании срока кредита', value: contract?.chargeExtraInterest || null },
    { label: 'Возможно погашение до срока при автоакцепте', value: contract?.allowPrepayment || null },
    { label: 'Штраф по календарным дням', value: contract?.calendarDaysPenalty || null },
    { label: 'Останавливать штрафы после окончания графика', value: contract?.stopPenaltyOnClose || null },
    {
      label: 'Продолжать применять ставку при просрочке после выхода из просрочки',
      value: contract?.keepUsingDelinqIntRate || null
    },
    {
      label: 'Использовать процентную ставку при просрочке для расчета ПСК',
      value: contract?.useDelinqIntRateForPsk || null
    },
    { label: 'Создавать новый график при пролонгации', value: contract?.prolongationOnNewSchedule || null },
    {
      label: 'Возвращение к регулярной процентной ставке со следующего транша после погашения просрочки',
      value: contract?.useDelinqIntRateTillNextTranche || null
    }
  ]
}

const getRequiredData = contract => {
  const collateralTypeId = contract?.collateralTypeId
  switch (collateralTypeId) {
    case 101760:
      return [
        { label: 'Акт на право частной собственности', value: contract?.estateTitleDeed || '-' },
        { label: 'Боковая сторона', value: contract?.estateSide || '-' },
        { label: 'Год постройки', value: contract?.estateConstructionYear || '-' },
        { label: 'Город', value: contract?.estateCity || '-' },
        { label: 'Дата и номер регистрации', value: contract?.estateRegistrationDateNumber || '-' },
        { label: 'Договор', value: contract?.estateAgreement || '-' },
        { label: 'Жилая площадь', value: contract?.estateLivingArea || '-' },
        { label: 'Кадастровый номер', value: contract?.estateCadastralNumber || '-' },
        { label: 'Количество комнат', value: contract?.estateRoomNumber || '-' },
        { label: 'Материал стен', value: contract?.estateWallMaterial || '-' },
        { label: 'Микрорайон', value: contract?.estateMicrodistrict || '-' },
        { label: 'Номер дома', value: contract?.estateHouseNumber || '-' },
        { label: 'Номер квартиры/комнаты', value: contract?.estateApartmentNumber || '-' },
        { label: 'Область', value: contract?.estateRegion || '-' },
        { label: 'Общая площадь', value: contract?.estateTotalArea || '-' },
        { label: 'Общее количество этажей', value: contract?.estateFloorsNumber || '-' },
        { label: 'Площадь земельного участка', value: contract?.estateLandArea || '-' },
        { label: 'Район', value: contract?.estateDistrict || '-' },
        { label: 'Тип недвижимости', value: contract?.estatePropertyType || '-' },
        { label: 'Улица', value: contract?.estateStreet || '-' },
        { label: 'Целевое значение земельного участка', value: contract?.estateLandUsePurpose || '-' },
        { label: 'Этаж', value: contract?.estateFloor || '-' }
      ]
    case 101754:
      return [
        { label: 'Адрес', value: contract?.estateAddress || '-' },
        { label: 'Состояние', value: contract?.estateCondition || '-' }
      ]
    default:
      return [
        {
          label: 'Первоначальный взнос тенге',
          value: `${contract?.initialPaymentAmount?.toString()?.thousandSeparator() || 0} ₸`
        },
        { label: 'Сумма займа', value: `${contract?.loanAmount?.toString()?.thousandSeparator() || 0} ₸` },
        { label: 'Марка', value: contract?.carMark || '-' },
        { label: 'Модель', value: contract?.carModel || '-' },
        { label: 'Год выпуска', value: contract?.carYear || '-' },
        { label: 'Автосалон', value: contract?.dealerShop || '-' },
        { label: 'Группа', value: contract?.dealerGroup || '-' },
        { label: 'Автомобиль', value: contract?.carName || '-' },
        { label: 'Первоначальный взнос %', value: contract?.initialPaymentRatio || '-' },
        { label: 'Цвет', value: contract?.carColor || '-' },
        { label: 'Состояние', value: contract?.carCondition || '-' },
        { label: 'Кузов', value: contract?.carBody || '-' }
      ]
  }
}

const getAdditionalData = contract => {
  const collateralTypeId = contract?.collateralTypeId
  if (collateralTypeId !== 101760 && collateralTypeId !== 101754) {
    return [
      { label: 'Пробег', value: contract?.carMileage || '-' },
      { label: 'Гос. номер', value: contract?.carPlate || '-' },
      { label: 'Свидетельство регистрации ТС', value: contract?.carRegistrationCertificate || '-' },
      { label: 'Дата регистрации', value: contract?.carRegistrationDate || '-' },
      { label: 'VIN', value: contract?.carVinCode || '-' }
    ]
  }
  return []
}

export const getProcuringData = contract => {
  const garants = [
    { clientId: contract?.firstGarantClientId, typeName: contract?.firstGarantTypeName },
    { clientId: contract?.secondGarantClientId, typeName: contract?.secondGarantTypeName },
    { clientId: contract?.thirdGarantClientId, typeName: contract?.thirdGarantTypeName },
    { clientId: contract?.fourthGarantClientId, typeName: contract?.fourthGarantTypeName },
    { clientId: contract?.fifthGarantClientId, typeName: contract?.fifthGarantTypeName }
  ]

  const validGarants = garants.filter(g => g.clientId)

  const data = [
    ...(validGarants.length > 0
      ? [
          {
            title: 'Гарант',
            line: true,
            data: validGarants.map((g, index) => ({
              label: `Гарант ${index + 1}`,
              value: g.typeName || '-'
            }))
          }
        ]
      : []),
    {
      title: 'Залог',
      hasChip: true,
      line: true,
      data: [
        {
          label: 'ФИО залогодателя',
          value: contract?.depositorFullName || '-'
        },
        { label: 'Предмет залога', value: contract?.collateralName || '-' },
        { label: 'Рыночная стоимость', value: `${contract?.assessedValue?.toString()?.thousandSeparator() || 0} ₸` },
        {
          label: 'Залоговая стоимость',
          value: `${contract?.hypothecationValue?.toString()?.thousandSeparator() || 0} ₸`
        },
        { label: 'Остаточная стоимость авто', value: `${contract?.loanValue?.toString()?.thousandSeparator() || 0} ₸` },
        { label: 'Документ основание', value: contract?.document || '-' },
        { label: 'Дополнительные комментарии', value: contract?.comment || '-' },
        { label: 'Дата договора залога', value: getValidDate(contract?.creationDate) }
      ]
    },
    {
      title: 'Обязательная информация',
      line: true,
      data: getRequiredData(contract)
    },
    {
      title: 'Дополнительная информация',
      line: true,
      data: getAdditionalData(contract)
    }
  ]

  return data
}
